<!--
 * @Author: tony.zhu
 * @Date: 2025-10-15 10:06:25
 * @LastEditTime: 2025-12-26 15:51:55
 * @LastEditors: tony.zhu
 * @Description: 
-->

<template>
  <div class="c-chat">
    <div class="c-chat__header">
      <div class="left_wrap">
        <span class="header-title">{{ chatSourceType === 'wenshu' ? 'AI问数' : chatSourceType === 'global' ? 'AI员工' : 'AI面试顾问' }}</span>
      </div>
      <div class="right_wrap" @click="drawerOnClose">
        <img src="@/components/aiChat/images/svg/shouqiIcon.svg" alt="" />
      </div>
    </div>
    <div class="c-chat__content" v-loading="historyLoading">
      <div class="c-chat__title" v-if="source !== 'global'">
        <img
          :src="interview?.resume_00011?.showValue || require('@/assets/images/defaultPerson.png')"
          class="touxiang"
        />
        <span style="margin-right: 10px">{{ interview?.resume_00013?.showValue }}</span>
        <p>
          <span style="margin-right: 10px">{{ interview.jobName }}</span>
          <span v-for="(item, index) in interview.evaluateEntityList" :key="index" style="margin-right: 10px">
            面试官{{ index + 1 }}：{{ item.userName }}
          </span>
        </p>
      </div>
      <Main
        :widgetMenuFormDataModelProp="widgetMenuFormDataModel"
        :activeRouteProp.sync="activeRoute"
        :suggestQuestionListProp="suggestQuestionList"
        :formModelDataProp="formModelData"
        :isDeepThinkingProp.sync="isDeepThinking"
        :isDisabledScrollProp.sync="isDisabledScroll"
        :paramsModelDataProp="paramsModelData"
        :historyLoading="historyLoading"
        @on-load-scroll="onLoadScroll"
        @on-query-dialogue="
          e => {
            onCreate(e)
          }
        "
        @on-stop-dialogue="onStopDialogue"
        @on-delete="onDelete"
        @on-sticky="onSticky"
        @on-un-sticky="onUnSticky"
        @on-reset-name="onResetName"
        @on-send-suggest-question="onSendSuggestQuestion"
        @on-reset-question="onResetQuestion"
        :interviewProp="interview"
        :source="source"
        v-if="isRender"
      ></Main>
    </div>
  </div>
</template>

<script>
import Main from './widgets/main.vue'
import { commonMixin } from '@/components/aiChat/common/mixins.js'
import { ANSWER_CONTENT_TYPE_ENUM } from '@/components/aiChat/common/notification.js'
import tool from '@/components/aiChat/utils/tbox.js'
import { fetchEventSourceManager } from '@/components/aiChat/utils/fetchEventSourceManager.js'
import { v4 as uuidv4 } from 'uuid'
import dayJs from 'dayjs'
import Storage from '@/components/aiChat/utils/storage'
import CustomSvgIcon from '@/components/aiChat/components/custom-svg-icon'
import { Api } from '@/api'

export default {
  components: {
    Main,
    CustomSvgIcon
  },
  props: {
    apiBaseUrl: {
      type: String,
      default: ''
    },
    // 建议问题列表
    suggestQuestionsProp: {
      type: Array,
      default() {
        return []
      }
    },
    interview: {
      type: Object,
      default() {
        return {}
      }
    },
    source: {
      type: String,
      default: ''
    }
  },
  mixins: [commonMixin],
  computed: {
    answerContentTypeEnum() {
      const answerContentTypeEnum = JSON.parse(JSON.stringify(ANSWER_CONTENT_TYPE_ENUM))
      return tool.changeMappingHandle(answerContentTypeEnum)
    }
  },
  data() {
    return {
      isDisabledScroll: false,
      isDeepThinking: false,
      suggestQuestionList: [
        // { label: "sd速度快水电费卡斯柯sds" }
      ],
      widgetMenuFormDataModel: {
        children: [
          {
            meta: {
              title: '开启新对话',
              level: 1,
              icon: 'xinjianduihuaIcon'
            }
          },
          {
            meta: {
              title: '历史对话',
              level: 1,
              icon: 'historyIcon',
              isShowSecondaryMenu: true,
              num: null,
              dynamic: true
            },
            children: [
              // {
              //   meta: {
              //     title:
              //       "1山东快书咖啡店聚飞光电凯撒开个房间国际服上课地方肯定是",
              //     level: 2,
              //     num: null,
              //     id: "2",
              //     fixed: false,
              //   },
              // },
            ]
          }
        ]
      },
      activeRoute: null,
      formModelData: {
        dialogueList: []
      },
      paramsModelData: {
        dialogueId: null
      },
      isCreate: false,
      aiTimer: null,
      isRender: true,
      historyLoading: false,
      autoScrollEnabled: true,
      chatSourceType: ''
    }
  },
  created() {
    this.$bus.$on('sourceType-change', (val) => {
      this.chatSourceType = val
      this.$store.commit('aiChat/setChatSourceType', val)
      // isRender重建期间跳过破坏性重置，避免对话记录和下拉状态丢失
      if (this._skipSourceTypeReset) return
      // 切换来源时，清空"置顶"和"我的对话"，重新请求列表
      this.dialogueList = []
      this.pageInfo = {
        total: 0,
        pages: null,
        pageNum: 1,
        pageSize: 20,
        finished: false,
        isMorePage: null
      }
      this.activeRoute = null
      this.formModelData = {
        ...this.formModelData,
        dialogueList: []
      }
      // 清空输入框和已上传图片，回到初始欢迎状态
      try {
        this.$bus.emit('on-change-field-by-custom-textarea', { key: 'value', value: '' })
        this.$bus.emit('on-change-field-by-custom-textarea', { key: 'uploadedImages', value: [] })
      } catch (error) {
        this.$bus.$emit('on-change-field-by-custom-textarea', { key: 'value', value: '' })
        this.$bus.$emit('on-change-field-by-custom-textarea', { key: 'uploadedImages', value: [] })
      }
      this.$nextTick(() => {
        this.onQueryDialogue({})
      })
    })
  },
  mounted() {
    console.log('interview', this.interview)
    this.onQueryDialogue({})

    // 监听返回数据
    fetchEventSourceManager.on('on-message', this.onMessage)

    // 监听关闭返回
    fetchEventSourceManager.on('on-close', this.onClose)
    //监听错误返回
    fetchEventSourceManager.on('on-error', this.onError)
    fetchEventSourceManager.on('on-open', this.onOpen)
    fetchEventSourceManager.on('on-manual-close-link', this.onCloseLink)
    fetchEventSourceManager.on('on-logout', this.onLogout)
  },
  methods: {
    onCreate(e) {
      // 创建新对话
      this.pageInfo.pageNum = 1

      this.formModelData = {
        ...this.formModelData,
        dialogueList: []
      }
      this.onQueryDialogue({
        type: 'more',
        isConcat: true
      })
      this.isCreate = true
      this.activeRoute = e
      const timer = setTimeout(() => {
        this.isCreate = false
        clearTimeout(timer)
      }, 10)
    },

    // 手动停止对话
    async onStopDialogue(id) {
      this.$store.commit('aiChat/setTextareaIsDisabled', false)
      const r = await this.onUpdateDialogueStop(id)
      if (r) {
        // 需清除当前对话的最后一个对话内容的回答
        this.formModelData.dialogueList.splice(this.formModelData.dialogueList.length - 1, 1)
        return Promise.resolve(true)
      }
    },

    // 重新生成
    onResetQuestion({ params, formModalData }) {
      console.log('onResetQuestion', params, formModalData)
      const busData = {
        questionMsg: formModalData.question.content[0].value,
        images: formModalData.question.images || [],
        tools: formModalData.question.tools || []
      }
      try {
        this.$bus.emit('on-send-suggest-question', busData)
      } catch (error) {
        this.$bus.$emit('on-send-suggest-question', busData)
      }
    },

    // 发送建议问题
    onSendSuggestQuestion(params) {
      this.paramsModelData = {
        dialogueId: null
      }
      try {
        this.$bus.emit('on-send-suggest-question', {
          questionMsg: params.label,
          cb: dialogueId => {
            this.activeRoute = dialogueId
          }
        })
      } catch (error) {
        this.$bus.$emit('on-send-suggest-question', {
          questionMsg: params.label,
          cb: dialogueId => {
            this.activeRoute = dialogueId
          }
        })
      }
    },

    // 重命名更新
    onResetName(params) {
      console.log(params)
      this.dialogueList = this.dialogueList.map(y => {
        if (y.meta.id == params.id) {
          y.meta.title = params.content
        }
        return { ...y }
      })
    },

    // 对话置顶
    async onSticky(params) {
      console.log(params)
      const res = await this.onUpdateDialogueTop({ id: params.params.id })
      if (res) {
        try {
          this.dialogueList.splice(0, 0, this.dialogueList.splice(params.index, 1)[0])
          this.$nextTick(() => {
            // this.dialogueList = this.dialogueList.map((t, i) => {
            //   return { ...t, index: i };
            // });
            this.pageInfo.pageNum = 1
            this.onQueryDialogue({
              type: 'more'
            })
          })
        } catch (error) {
          console.log(error)
        }
      }
    },

    // 取消置顶
    async onUnSticky(params) {
      console.log(params)
      const res = await this.onUpdateDialogueUnTop({ chatId: params.params.id })
      if (res) {
        try {
          this.dialogueList.splice(params.index, 1)
          this.$nextTick(() => {
            // this.dialogueList = this.dialogueList.map((t, i) => {
            //   return { ...t, index: i };
            // });
            this.pageInfo.pageNum = 1
            this.onQueryDialogue({
              type: ''
            })
          })
        } catch (error) {
          console.log(error)
        }
      }
    },

    // 删除对话
    async onDelete(params) {
      console.log(params)
      //debugger
      let relIndex = params.index
      const res = await this.onDeleteDialogue(params.params.id)
      if (res) {
        try {
          // TODO 获取总页数的集合
          const dialogueList = [...this.dialogueList]
          const pageInfo = { ...this.pageInfo }
          dialogueList.splice(params.index, 1)
          this.dialogueList = dialogueList
          pageInfo.total = --pageInfo.total
          this.pageInfo = pageInfo

          const pageNumTotal = tool.pageCount(pageInfo.total, this.pageInfo.pageSize) // 计算当前总页数
          const pageNumList = [
            ...Array.from({
              length: pageNumTotal + 1
            }).keys()
          ]
          pageNumList.shift()
          // TODO 获取 总条数的数组集合
          const totalList = [
            ...Array.from({
              length: pageInfo.total
            }).keys()
          ]
          // TODO 便利获取当前索引的下的属于哪个页数集合的页数
          let p = null
          for (let v = 0; v < pageNumList.length; v++) {
            let f = false
            for (let i = 0; i < totalList.length; i++) {
              if (params.index / this.pageInfo.pageSize < pageNumList[v]) {
                f = true
              }
            }
            if (f) {
              p = pageNumList[v]
              break
            }
          }
          console.log(p, 'p', pageNumList, totalList, params)
          pageInfo.isMorePage = p // isMorePage
          this.pageInfo = pageInfo
          this.$nextTick(async () => {
            const bn = await this.onQueryDialogue({ type: 'more' })
            if (bn) {
              if (this.dialogueList.length == 0) {
                pageInfo.isMorePage = null
                pageInfo.pageNum = 1
                this.activeRoute = null
              } else {
                let i = null
                if (params.params.id === this.activeRoute) {
                  // 删的是当前激活的自己
                  const okl = this.dialogueList[relIndex]
                  if (okl) {
                    i = relIndex
                  } else {
                    i = relIndex - 1 <= 0 ? 0 : relIndex - 1
                  }
                }
                if (i === null) {
                } else {
                  this.activeRoute = this.dialogueList[i].id
                }
              }
            }
          })
        } catch (error) {
          console.log(error)
        }
      }
    },

    async onLoadScroll() {
      console.log('load')
      this.isDisabledScroll = true
      if (
        // this.dialogueList.length === this.pageInfo.total ||
        this.pageInfo.finished
      ) {
        this.isDisabledScroll = false
        return
      }
      let bn = null
      if (this.pageInfo.isMorePage) {
        bn = await this.onQueryDialogue({ type: 'more' })
      } else {
        this.pageInfo.pageNum = ++this.pageInfo.pageNum
        bn = await this.onQueryDialogue({ type: 'more' })
      }
      if (bn) {
        this.isDisabledScroll = false
      }
    },

    async onQueryDialogueDetailFormatData(id) {
      try {
        //先暂停定时器
        this.stopPolling()
        this.historyLoading = true
        this.formModelData = {
          ...this.formModelData,
          dialogueList: []
        }
        const res = await this.onQueryDialogueDetailById({
          chatId: id,
          pageNum: 1,
          pageSize: 1000000
        })

        if (Array.isArray(res) && res.length) {
          // 处理存储的对话是否显示loading
          let dialogueMap = null
          try {
            const dialogueMapArr = Storage.get('dialogueMap')
            dialogueMap = new Map(dialogueMapArr)
          } catch (error) {
            console.log(error)
          }

          res.forEach(r => {
            // 优先以后端 status 判断是否正在思考，避免 dialogueMap 被 SSE 关闭清除后 loading 丢失
            let loading = r.status === 1
            if (dialogueMap && dialogueMap.has(r.chatId)) {
              loading = true
              if (r.answer) {
                // 判断下r如果answer有数据 就清除本地loading记录
                loading = false
                const config = { body: JSON.stringify(dialogueMap.get(r.chatId)) }
                fetchEventSourceManager.onClearDialogueMap(config)
              }
            }

            const questionObj = {
              id: uuidv4(),

              type: 'question',
              content: [
                {
                  type: 'message',
                  value: r.question,
                  id: uuidv4()
                }
              ]
            }

            let content = []
            if (r.answer) {
              content = [
                {
                  type: 'message',
                  value: r.answer.replace('<think>', '<think>\n').replace('</think>', '</think>\n'),
                  id: r.roomId || r.id
                }
              ]
            }
            const answerObj = {
              id: uuidv4(),

              loading,
              type: 'answer',
              content
            }

            let obj = {
              id: r.id,
              responseData: {
                ...r
              },
              question: {
                ...questionObj
              },
              answer: {
                ...answerObj
              }
            }
            if (r.attachment) {
              obj.question.tools = JSON.parse(r.attachment)
            }
            if (r.images) {
              obj.question.images = typeof r.images === 'string' ? JSON.parse(r.images) : r.images
            }
            if (r.knowledgeDocument) {
              try {
                obj.answer.knowledgeDocument = typeof r.knowledgeDocument === 'string' ? JSON.parse(r.knowledgeDocument) : r.knowledgeDocument
              } catch (e) {
                obj.answer.knowledgeDocument = []
              }
            }

            this.formModelData.dialogueList.push(obj)
          })
          console.log(this.formModelData.dialogueList)

          this.$nextTick(() => {
            this.onGoBottom()
          })
        } else {
          this.formModelData = {
            ...this.formModelData,
            dialogueList: []
          }
        }
        this.historyLoading = false
        this.$store.commit('aiChat/setTextareaIsDisabled', false)

        //正在思考的轮询
        let message = null
        for (let i = 0; i < this.formModelData.dialogueList.length; i++) {
          const one = this.formModelData.dialogueList[i]
          if (one?.responseData?.status === 1) {
            message = one
            break
          }
        }
        if (message) {
          // 确保"正在思考"状态在轮询期间可见
          if (message.answer) {
            message.answer.loading = true
          }
          this.thinkingPolling(message)
        }
      } catch (error) {
      this.historyLoading = false
    }
    },

    //正在思考的轮询
    thinkingPolling(message) {
      if (this.aiTimer === null) {
        this.aiTimer = setInterval(() => {
          //如果窗口关闭了，就停止
          if (!this.$store.state.aiChat.aiChatDrawerVisible) {
            this.stopPolling()
            return
          }
          this.$store.commit('aiChat/setTextareaIsDisabled', true)
          Api.aiGetChatMessage({
            messageId: message.id
          })
            .then(res => {
              if (res.code === '0' && res.data) {
                // console.log(this.formModelData.dialogueList)
                if (res.data.status === 0) {
                  // 318828 这里是思考完毕 我的对话切换后，完整显示内容
                  const chatId = message?.responseData?.chatId
                  const obj = this.formModelData.dialogueList.find(item => item.responseData?.chatId === chatId)
                  if (obj && obj.answer && obj.answer.content && obj.answer.content.length > 0 && res.data.answer) {
                    obj.answer.content[0].value = res.data.answer.replace('<think>', '<think>\n').replace('</think>', '</think>\n')
                  } else if (res.data.answer) {
                    // 这里是正在思考，重新打开窗口
                    message.answer.loading = false
                    message.answer.content = [
                      {
                        type: 'message',
                        value: res.data.answer.replace('<think>', '<think>\n').replace('</think>', '</think>\n'),
                        id: res.data.roomId || res.data.id
                      }
                    ]
                  }
                  this.stopPolling()
                  const savedActiveRoute = this.activeRoute
                  // 标记重建期间跳过sourceType-change的破坏性重置
                  this._skipSourceTypeReset = true
                  this.isRender = false
                  this.$nextTick(() => {
                    this.isRender = true
                    this.$nextTick(() => {
                      this._skipSourceTypeReset = false
                      // 恢复当前对话，避免跳回默认状态
                      if (savedActiveRoute !== null) {
                        this.activeRoute = savedActiveRoute
                      }
                      this.onGoBottom()
                    })
                  })
                }
              } else {
                this.stopPolling()
              }
            })
            .catch(err => {
              console.log(err)
              this.stopPolling()
            })
        }, 1000)
      }
    },
    stopPolling() {
      if (this.aiTimer) {
        this.$store.commit('aiChat/setTextareaIsDisabled', false)
        clearInterval(this.aiTimer)
        this.aiTimer = null
      }
    },

    onError({ data, body }) {
      console.log(data, body, 'onError')
      this.$store.commit('aiChat/setTextareaIsDisabled', false)
      try {
        this.$bus.emit('on-change-field-by-custom-textarea', {
          key: 'isDisabled',
          value: false
        })
      } catch (error) {
        this.$bus.$emit('on-change-field-by-custom-textarea', {
          key: 'isDisabled',
          value: false
        })
      }

      // if (data.code == "514") {
      //   this.$refs.dialogEmpty.onShow({
      //     title: "",
      //     operateType: "DELIST",
      //     size: "360px",
      //   });
      //   this.lastDialogueList.splice(this.lastDialogueList.length - 1, 1);
      // } else if (data.code == "515") {
      //   this.lastDialogueList.splice(this.lastDialogueList.length - 1, 1);
      //   this.$message.error(data.message);
      // } else if (data.code == "516") {
      //   // 需要处理 错误文案
      //   const obj = this.lastDialogueList[this.lastDialogueList.length - 1];
      //   obj.answer.chatAiResult = "error";
      //   obj.answer.content[0] = {
      //     value: data.message,
      //     type: this.answerContentTypeEnum.Object.TEXT.code,
      //     id: "",
      //   };
      //   obj.answer.loading = false;
      //   this.lastDialogueList = this.lastDialogueList.map((r, i) => {
      //     let o = {
      //       ...r,
      //     };
      //     if (i == this.lastDialogueList.length - 1) {
      //       o = {
      //         ...obj,
      //       };
      //     }
      //     return o;
      //   });
      // } else {
      // this.formModelData.dialogueList.splice(
      //   this.formModelData.dialogueList.length - 1,
      //   1
      // );
      // this.$message.error();
      // }
    },

    onCloseLink() {
      this.$store.commit('aiChat/setTextareaIsDisabled', false)
      this.formModelData.dialogueList = this.formModelData.dialogueList.map((r, i) => {
        let o = {
          ...r
        }
        if (i == this.formModelData.dialogueList.length - 1) {
          o = {
            ...o,
            answer: {
              id: o.answer.id || uuidv4(),
              loading: false,
              streaming: false,
              type: 'answer',
              content: []
            }
          }
        }
        return o
      })
    },

    onClose({ data, body }) {
      console.log(data, body, 'onClose')
      this.$store.commit('aiChat/setTextareaIsDisabled', false)
      this.$nextTick(async () => {
        try {
          this.$bus.emit('on-change-field-by-custom-textarea', {
            key: 'isDisabled',
            value: false
          })
        } catch (error) {
          this.$bus.$emit('on-change-field-by-custom-textarea', {
            key: 'isDisabled',
            value: false
          })
        }

        if (data) {
          this.formModelData.dialogueList = this.formModelData.dialogueList.map((r, i) => {
            let o = {
              ...r
            }
            if (data?.knowledge_document) {
              try {
                o.answer.knowledgeDocument = JSON.parse(data.knowledge_document)
              } catch (e) {
                o.answer.knowledgeDocument = []
              }
            }
            if (i == this.formModelData.dialogueList.length - 1) {
              // 流式结束，关闭 streaming 状态，操作按钮可以显示了
              o.answer = { ...o.answer, streaming: false }
              if (data?.messageId) {
                o.id = data.messageId
              }
            }
            return o
          })
        }
        this.onGoBottom()
      })
    },

    onMessage({ data, body }) {
      this.$store.commit('aiChat/setTextareaIsDisabled', true)
      if (body.id !== this.activeRoute) {
        this.onChangeTextareaField('loading', false)
        this.$store.commit('aiChat/setTextareaIsDisabled', false)
        return
      }
      this.onChangeTextareaField('loading', true)
      console.log(data, body, 'onMessage')
      // 这样会有点问题 切换路由时 会没拿到带<think>的数据 导致深度思考的样式会没有了
      let newContent = data?.data?.content ? data.data.content.toString() : ''
      if (newContent && newContent.indexOf('<think>') >= 0) {
        newContent += newContent.replace('<think>', '<think>\n')
      }
      if (newContent && newContent.indexOf('</think>') >= 0) {
        newContent += newContent.replace('</think>', '</think>\n')
      }
      if (this.formModelData.dialogueList.length) {
        const content = [...this.formModelData.dialogueList[this.formModelData.dialogueList.length - 1].answer.content]
        if (content.length == 0) {
          // 没有长度 就先新增一个
          // if (data.event == this.answerContentTypeEnum.Object.TEXT.code) {
          if (newContent) {
            content.push({
              type: this.answerContentTypeEnum.Object.TEXT.code,
              id: data.data.id || uuidv4(),
              value: newContent
            })
          }
          // }
        } else {
          for (let i = 0; i < content.length; i++) {
            // if (data.event == this.answerContentTypeEnum.Object.TEXT.code) {
            content[i].value += newContent
            // }
          }
        }

        const obj = this.onFormatItemDialogue({
          ...body,
          loading: false,
          streaming: true,
          id: data.data.id || uuidv4() || '',
          answerContent: content
          // event: data.event || "",
        })

        this.paramsModelData = {
          dialogueId: body.id
        }

        this.formModelData.dialogueList = this.formModelData.dialogueList.map((r, i) => {
          let o = {
            ...r
          }
          if (i == this.formModelData.dialogueList.length - 1) {
            o = {
              ...obj
            }
            const prevKnowledge = r.answer?.knowledgeDocument
            if (data?.data?.knowledge_document) {
              try {
                o.answer.knowledgeDocument = JSON.parse(data.data.knowledge_document)
              } catch (e) {
                o.answer.knowledgeDocument = prevKnowledge || []
              }
            } else if (prevKnowledge) {
              o.answer.knowledgeDocument = prevKnowledge
            }
          }
          return o
        })

        this.$nextTick(() => {
          this.onGoBottom(true)
        })
      }
    },

    onOpen({ data, body }) {
      console.log(data, body, 'onOpen')
      if (body.id !== this.activeRoute) {
        this.onChangeTextareaField('loading', false)
        return
      }
      this.autoScrollEnabled = true
      this.onChangeTextareaField('loading', true)

      // 初始化一条信息
      const obj = this.onFormatItemDialogue({
        ...body,
        loading: true,
        streaming: true,
        answerContent: []
        // event: "",
      })
      console.log(obj, 'objobjobjobj')
      this.formModelData = {
        ...this.formModelData,
        dialogueList: this.formModelData.dialogueList.concat(obj)
      }
      this.pageInfo.total = String(Number(this.pageInfo.total) + 1)

      this.$nextTick(() => {
        this.onGoBottom()
      })
    },

    onChangeTextareaField(key, value) {
      try {
        this.$bus.emit('on-change-field-by-custom-textarea', {
          key: key,
          value: value
        })
      } catch (error) {
        this.$bus.$emit('on-change-field-by-custom-textarea', {
          key: key,
          value: value
        })
      }
    },

    async onGoBottom() {
      if (!this.autoScrollEnabled) return
      const dom = document.querySelector('.c-dialogue  .el-scrollbar__wrap')
      if (!dom) return
      // 懒绑定滚动监听（DOM 重建后自动重新绑定）
      if (this._scrollWrapEl !== dom) {
        this.detachScrollListener()
        dom.addEventListener('scroll', this.onScrollEvent)
        this._scrollWrapEl = dom
      }
      await this.goBottom(dom)
    },

    onScrollEvent(e) {
      clearTimeout(this._scrollDebounceTimer)
      this._scrollDebounceTimer = setTimeout(() => {
        const node = e.target
        const isNearBottom = node.scrollHeight - node.scrollTop - node.clientHeight < 50
        this.autoScrollEnabled = isNearBottom
      }, 150)
    },

    detachScrollListener() {
      if (this._scrollWrapEl) {
        this._scrollWrapEl.removeEventListener('scroll', this.onScrollEvent)
        this._scrollWrapEl = null
      }
    },

    // 处理数据
    onFormatItemDialogue(params) {
      let obj = {
        ...params,
        dialogueId: params.dialogueId || '',
        question: {
          type: 'question',
          time: dayJs().format('HH:mm'),
          // id: params.recordId,
          content: [
            {
              type: this.answerContentTypeEnum.Object.TEXT.code,
              // id: params.recordId,
              value: params.question
            }
          ],
          tools:
            params.attachments && params.attachments instanceof Array && params.attachments.length > 0
              ? JSON.parse(JSON.stringify(params.attachments))
              : [],
          images:
            params.images && params.images instanceof Array && params.images.length > 0
              ? JSON.parse(JSON.stringify(params.images))
              : []
        },
        answer: {
          type: 'answer',
          time: dayJs().format('HH:mm'),
          loading: params.loading || false,
          streaming: params.streaming || false,
          // id: params.recordId,
          content: params.answerContent || []
        }
      }
      return obj
    },

    onLogout() {
      this.$emit('on-logout')
    },
    drawerOnClose() {
      this.$emit('close')
      this.$store.commit('aiChat/setVisible', false)
    }
  },
  watch: {
    apiBaseUrl: {
      handler: function (n) {
        window.__apiBaseUrl__ = n
      },
      immediate: true
    },
    suggestQuestionsProp: {
      handler: function (n) {
        this.suggestQuestionList = n || []
      },
      deep: true,
      immediate: true
    },
    dialogueList: {
      handler: function (n) {
        this.widgetMenuFormDataModel.children[1].children = n || []
      },
      immediate: true,
      deep: true
    },
    activeRoute: {
      handler: function (n, o) {
        console.log('activeRoute', n, o)
        this.autoScrollEnabled = true
        this.paramsModelData = {
          dialogueId: n
        }
        if (n !== null) {
          if (!this.isCreate) {
            this.onQueryDialogueDetailFormatData(n)
          } else {
          }
        } else {
          this.onChangeTextareaField('loading', false)
        }
      },
      immediate: true
    }
  },
  beforeDestroy() {
    this.isCreate = false
    this.$bus.$off('sourceType-change')
    this.detachScrollListener()
    clearTimeout(this._scrollDebounceTimer)
    fetchEventSourceManager.onCloseLink({})
    // 监听返回数据
    fetchEventSourceManager.off('on-message', this.onMessage)

    // 监听关闭返回
    fetchEventSourceManager.off('on-close', this.onClose)
    //监听错误返回
    fetchEventSourceManager.off('on-error', this.onError)
    fetchEventSourceManager.off('on-open', this.onOpen)
    fetchEventSourceManager.off('on-manual-close-link', this.onCloseLink)

    fetchEventSourceManager.off('on-logout', this.onLogout)
  }
}
</script>

<style lang="scss" scoped>
//@import "styles/index.scss";

.c-chat {
  background: url('~@/components/aiChat/images/duihuabeijing.png') no-repeat;
  height: 100%;
  background-size: 100% 100%;
  .c-chat__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    background: rgba(255, 255, 255, 0.3);
    box-shadow: inset 0px 0px 0px 0px rgba(255, 255, 255, 0.5);
    backdrop-filter: blur(2px);
    height: 56px;
    .left_wrap {
      display: flex;
      align-items: center;

      .logo {
        width: 32px;
        height: 32px;
      }
      .icon {
        width: 77px;
        height: 28px;
        margin-left: 12px;
      }
      img {
        width: 97px;
        height: 28px;
      }
      .header-title {
        font-size: 16px;
        font-weight: 600;
        color: #1d2129;
        margin-left: 8px;
        white-space: nowrap;
      }
    }
    .right_wrap {
      cursor: pointer;
      .icon {
        width: 24px;
        height: 24px;
        cursor: pointer;
      }
    }
  }

  .c-chat__content {
    height: calc(100% - 56px);
  }
}
.c-chat__title {
  display: flex;
  height: 48px;
  padding: 0 16px;
  .touxiang {
    width: 32px;
    height: 32px;
    border-radius: 32px;
    margin-top: 8px;
    margin-right: 8px;
  }
  span {
    line-height: 48px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #1d2129;
    font-style: normal;
  }
  p {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #1d2129;
    line-height: 48px;
    font-style: normal;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 900px;
  }
}
</style>
